<template>
  <div class="scene">
    <div class="changeTitle">请选择登陆场景</div>
    <div class="changeHeng">
      <div></div>
    </div>

    <div class="box">
      <div class="flex jcc sceneSelect">
        <div
          class="box_1"
          v-if="sceneInfoStr.indexOf('2') != -1"
          @click="school"
        >
          <img
            class="w320 h280"
            src="../assets/images/Mask group@2x.png"
            alt=""
          />
          <div class="sceneChangeContent">
            <div class="sceneTitle">校园场景</div>
            <div class="sceneContent">
              放置在校园场景下的设备信息可进入校园场景查看
            </div>
          </div>
        </div>
        <div
          class="box_1"
          v-if="sceneInfoStr.indexOf('3') != -1"
          @click="community"
        >
          <img
            class="w320 h280"
            src="../assets/images/Mask group@2x(1).png"
            alt=""
          />
          <div class="sceneChangeContent">
            <div class="sceneTitle">社区场景</div>
            <div class="sceneContent">
              放置在社区场景下的设备信息可进入社区场景查看
            </div>
          </div>
        </div>
        <div
          class="box_1"
          v-if="sceneInfoStr.indexOf('1') != -1"
          @click="scenic"
        >
          <img
            class="w320 h280"
            src="../assets/images/Mask group@2x(2).png"
            alt=""
          />
          <div class="sceneChangeContent">
            <div class="sceneTitle">景区场景</div>
            <div class="sceneContent">
              放置在景区场景下的设备信息可进入景区场景查看
            </div>
          </div>
        </div>
        <!-- <span 
          >校园场景</span
        >
        <span  class="box_font"
          >社区场景</span
        >
        <span  class="box_font"
          >景区场景</span
        > -->
      </div>
      <!-- <div class="  center pdt-80 bomtext">请 选 择 登 录 场 景</div> -->
    </div>
  </div>
</template>

<script>
import store from "../store";

export default {
  data() {
    return {
      sceneInfoStr: "",
    };
  },
  created() {
    this.getsceneInfo();
  },
  methods: {
    getsceneInfo() {
      let sceneInfo = JSON.parse(localStorage.getItem("sceneInfo"));
      this.sceneInfoStr = sceneInfo.join(",");
    },
    school() {
      window.sessionStorage["sceneId"] = 2;
      window.sessionStorage["sceneName"] = "校园场景";
      this.$api.system
        .sceneChange({ sceneId: 2, sceneName: "校园场景" })
        .then((res) => {
          // console.log(res, "校园");
          this.$router.push("/");
        });
      // var sceneId = store.getters.get_sceneId;
      // console.log(sceneId, "场景");
    },
    community() {
      window.sessionStorage["sceneId"] = 3;
      window.sessionStorage["sceneName"] = "社区场景";
      this.$api.system
        .sceneChange({ sceneId: 3, sceneName: "社区场景" })
        .then((res) => {
          console.log(res, "社区");
        });
      this.$router.push("/");

      var sceneId = store.getters.get_sceneId;
      // console.log(sceneId, "场景");
    },
    scenic() {
      // console.log(888);
      // this.$router.push("/");
      // this.$store.dispatch("set_sceneId", 1);
      window.sessionStorage["sceneId"] = 1;
      window.sessionStorage["sceneName"] = "景区场景";
      this.$api.system
        .sceneChange({ sceneId: 1, sceneName: "景区场景" })
        .then((res) => {
          this.$router.push("/");
        });
      var sceneId = store.getters.get_sceneId;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 场景选择页（过渡页）：响应式 + 主题适配优化。
   只改样式，不动模板/脚本/接口；卡片改为常规流式卡片（去掉 bottom:-90px 绝对定位叠加），
   flex-wrap + clamp 宽度自适应屏幕，背景接主题 --app-bg 与全站一致。 */
.scene {
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 56px 24px 72px;
  background: var(--app-bg);
}

.changeTitle {
  font-size: clamp(24px, 2.4vw, 34px);
  font-weight: bold;
  color: var(--accent);
  line-height: 1.3;
  text-align: center;
  letter-spacing: 2px;
  text-shadow: var(--stat-glow);
}

.changeHeng {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 18px;
  div {
    width: 96px;
    height: 6px;
    background: var(--brand-grad);
    border-radius: 8px;
  }
}

.box {
  width: 100%;
  max-width: 1200px;
  margin-top: 56px;
}

.sceneSelect {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
}

.box_1 {
  cursor: pointer;
  width: clamp(240px, 26vw, 320px);
  margin: 18px;
  display: flex;
  flex-direction: column;
  border-radius: 40px;
  overflow: hidden;
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  box-shadow: var(--card-shadow);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;

  img {
    width: 100% !important;
    height: auto !important;
    display: block;
  }

  .sceneChangeContent {
    flex: 1;
    padding: 22px 20px 26px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    transition: background 0.25s ease;
    .sceneTitle {
      color: var(--accent);
      font-size: clamp(20px, 1.6vw, 26px);
      font-weight: bold;
    }
    .sceneContent {
      margin-top: 14px;
      font-size: 15px;
      line-height: 1.6;
      color: var(--text-muted);
    }
  }
}

.box_1:hover {
  transform: translateY(-8px);
  border-color: var(--accent);
  box-shadow: 0 18px 40px rgba(12, 60, 120, 0.22);
  .sceneChangeContent {
    background: var(--brand-grad);
  }
  .sceneTitle {
    color: #fff;
  }
  .sceneContent {
    color: rgba(255, 255, 255, 0.85);
  }
}

/* 窄屏：卡片放大到接近整宽并纵向堆叠，标题/间距收敛 */
@media (max-width: 900px) {
  .scene {
    padding: 40px 16px 56px;
  }
  .box {
    margin-top: 32px;
  }
  .box_1 {
    width: clamp(220px, 82vw, 360px);
    margin: 12px;
  }
}
</style>
